<template>
  <div class="row m-0">
    <div class="col-xl-9 col-lg-9 col-md-9 pr-0">
      <div class="gallery-slider-container screen-height">
        <div class="zoom-box" style="z-index: 99999;">
          <div class="zoom-out">
            <button id="zoom-out">
              <img class="img-responsive" src="@/assets/images/minus-zoom.png" alt="shap" @click="canvasZoomOut">
            </button>
          </div>
          <div class="zoom-input">
            <input type="range" id="zoom-input"  v-model="zoomRange" min="0" max="1000" step="10" class="slider">
          </div>
          <div class="zoom-in">
            <button id="zoom-in" style="z-index: 99999;">
              <img class="img-responsive" src="@/assets/images/plus-zoom.png" alt="shap" @click="canvasZoomIn">
            </button>
          </div>
        </div>
        <a href="#" class="btn-expand pr-2" @click="toggleSliderView">
          <img src="@/assets/images/expand-icons.png" class="float-right pr-3" alt="logo">
        </a>
        <div class="gallery-slider text-center pos-rel" style="height:100%">
          <div class="gallery-slider-box d-none" style="position:relative; overflow: hidden; ">
            <img v-if="this.$parent.is_loading" class="img-fluid"  src="@/assets/images/timeout.gif" alt="img1" style="max-height: 77%; margin-top: 5rem;">
            <img v-else class="img" id="img" :src="image.src"  alt="logo">
          </div>


          <div id="canvas_div" class="canvas_div" style="height:100%">
            <canvas ref="detailcanvas" id="canvass"></canvas>
          </div>

          <a  @click="previousImage()">
            <img src="@/assets/images/pdarrow_left.png" class="arrow-gal-left" alt="logo"  style="width:1.5rem">
          </a>
          <a @click="nextImage()">
            <img src="@/assets/images/pdarrow_right.png" class="arrow-gal-right" alt="logo" style="width:1.5rem">
          </a>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 pl-none">
      <div class="right-sidebar">
        <!-- display on mobile only -->
        <div class="container-fluid d-block d-sm-none">
          <div class="button-areas">
            <div class="row border-bottom pt-2 pb-1">
              <div class="right-btn col-xl-6 col-lg-6 col-md-6 text-left">
                <button type="button" class="btn btn-light">
                  <img class="plus-img" src="@/assets/images/download.png"> Plan herunterladen </button>
                <button type="button" class="btn btn-light ml-2" id="edit-sidebtn"><img class="plus-img" src="@/assets/images/bpen.png"> Bearbeiten</button>
              </div>
            </div>
          </div>
        </div>
        <!-- end -->
        <DetailsFilters></DetailsFilters>
      </div>
    </div>
  </div>
</template>

<script>

import DetailsFilters from './DetailsFilters'
import {mapState} from 'vuex'
import {fabric} from 'fabric'
export default {
  data () {
    return {
      currentImage: this.$parent.currentImage,
      photos: this.$parent.photos,
      currentSliderImg: {},
      zoom_value: 3,
      canvasref: null,
      canvas: null,
      zoomRange: 10,
      zoomLevel: 10,
    }
  },
  // props: ['bus'],
  components: {
    DetailsFilters
  },
  activated: function(){
    console.log('SliderDetails --- activated', this._inactive, this.image.src)
  },
  computed: {
    ...mapState({
      image: state => state.photo.slider_active_image
    })
  },
  mounted () {
    console.log('Mounting SliderDetails')
    let _this = this
    this.getLargeImage(this.currentImage)
    // this.bus.$on('loadPreview', function() {
    //   _this.getLargeImage(_this.$store.state.photo.slider_active_image)
    //   console.log('SliderDetails --- BUS DRIVING!')
    // })
  },
  watch: {
    'zoomRange': async function () {
      let obj = this
      if (obj.zoomRange >= 1 && obj.zoomRange <= 1000) {
        let canvas = obj.canvas
        let c = (obj.zoomRange / 55) + 1
        canvas.zoomToPoint({x: canvas.getWidth() / 2, y: canvas.getHeight() / 2}, c)
        canvas.setZoom(c)
        await obj.canvas.getObjects().forEach(await function (point) {
          if (point.get('type') === 'group') {
            obj.setPointsZoom(obj.zoomRange, point)
          }
        })
        obj.imagesPopup = false
        obj.selectedFlagPhoto = null
        canvas.remove(...canvas.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
        // Change The Zoom Level By Changing The Zoom
        obj.setZoomLevel()
      }
    },

    'zoomLevel': async function () {
      let obj = this
      let c = obj.canvas
      c.remove(...c.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
    },

    '$store.state.photo.slider_active_image': function(value) {
      this.getLargeImage(value)
    },
    // 'zoom_value': function () {
    //   this.resize(this.zoom_value)
    // }
  },
  methods: {


    // Build canvas
    makeCanvas() {

      if (!(this.canvas === null || this.canvas === undefined)) {
        this.canvas.clear()
        this.canvas.dispose()
      }
      const canvas_ref = this.$refs.detailcanvas
      let canvas = new fabric.Canvas(canvas_ref,
        {
          selection: false,
          controlsAboveOverlay: true,
          centeredScaling: false,
          allowTouchScrolling: false,
          hasBorders: false,
          lockRotation: true,
          lockMovement: false,
          lockMovementY: false,
          lockMovementX: false,
          lockUniScaling: false,
          lockScalingY: true,
          lockScalingX: true,
        })

        this.canvas = canvas
        this.setCanvasBackground(canvas)

    },

    async setCanvasBackground(canvas) {
      let _this = this
      await fabric.Image.fromURL(_this.image.src, function (img) {

        let canvas_div = document.getElementById('canvas_div')

        let image_width = img.width
        let image_height = img.height

        let canvas_height = canvas_div.offsetHeight
        let canvas_width = canvas_div.offsetWidth


        canvas.setWidth(canvas_width)
        canvas.setHeight(canvas_height)


        // calc max width/height
        let ratio

        if(image_width > image_height && canvas_width > canvas_height) {
          ratio = image_height / image_width
          image_width = canvas_width
          image_height = image_width * ratio
        } else {
          ratio = image_width / image_height
          image_height = canvas_height
          image_width = image_height * ratio
        }

        img.set({
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          scaleX: canvas_width / image_width,
          scaleY: canvas_height / image_height,
        })
        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
          originX: 'center',
          originY: 'center',
          scaleX: canvas_width / image_width,
          scaleY: canvas_height / image_height,
        })


        canvas.centerObject(img)
        _this.setEventsOnCanvas(canvas)
        // obj.canvas = canvas
        canvas.renderAll()

        canvas.centerObject(img)

      })

    },

    setEventsOnCanvas(canvas) {
      let obj = this

      canvas.on('mouse:wheel', function (opt) {
        if (obj.zoomRange >= 10 && obj.zoomRange <= 1000) {
          (opt.e.deltaY > 0) ? obj.canvasZoomOut() : obj.canvasZoomIn()
        } else {
          obj.zoomRange = 10
        }
      })

      canvas.on('mouse:down', function (e) {
        obj.panning = true
        if (!e.target) {
          //
        }
      })

      canvas.on('mouse:up', function (e) {
        obj.panning = false
        if (!e.target) {
          //
        }
      })

      canvas.on('object:moving', function () {
        // console.log('Canvas- MouseMoving', obj)
        obj.panning = false
        //
      })

      canvas.on('mouse:move', function (e) {

        if (obj.panning && e && e.e) {
          // console.log('Canvas- MouseMove', obj.panning, e, e.e)
          let delta = new fabric.Point(e.e.movementX, e.e.movementY)
          canvas.relativePan(delta)
          let canvasViewPort = canvas.viewportTransform

          let bottomEndPoint = canvas.height * (canvasViewPort[0] - 1)
          if (canvasViewPort[5] >= 0 || -bottomEndPoint > canvasViewPort[5]) {
            canvasViewPort[5] = (canvasViewPort[5] >= 0) ? 0 : -bottomEndPoint
          }
          let rightEndPoint = canvas.width * (canvasViewPort[0] - 1)
          if (canvasViewPort[4] >= 0 || -rightEndPoint > canvasViewPort[4]) {
            canvasViewPort[4] = (canvasViewPort[4] >= 0) ? 0 : -rightEndPoint
          }
        }
      })
    },

    getZoomArea(inst) {

    },

    canvasZoomIn () {
      let obj = this
      this.getZoomArea(obj)
      if (obj.zoomRange <= 1000) {
        obj.zoomRange += 10
      }
    },

    canvasZoomOut () {
      let obj = this
      this.getZoomArea(obj)
      if (obj.zoomRange >= 0) {
        obj.zoomRange -= 10
      }
    },

    //Set a Zoom Level
    setZoomLevel () {
      let obj = this
      let zoom = this.zoomRange
      if (zoom >= 1 && zoom <= 50) {
        obj.zoomLevel = 10
      }
      if (zoom >= 51 && zoom <= 100) {
        obj.zoomLevel = 9
      } else if (zoom >= 101 && zoom <= 150) {
        obj.zoomLevel = 8
      } else if (zoom >= 151 && zoom <= 160) {
        obj.zoomLevel = 7
      } else if (zoom >= 201 && zoom <= 220) {
        obj.zoomLevel = 6
      } else if (zoom >= 251 && zoom <= 270) {
        obj.zoomLevel = 5
      } else if (zoom >= 301 && zoom <= 320) {
        obj.zoomLevel = 4
      } else if (zoom >= 351 && zoom <= 370) {
        obj.zoomLevel = 3
      } else if (zoom >= 401 && zoom <= 430) {
        obj.zoomLevel = 2
      } else if (zoom >= 500 && zoom <= 550) {
        obj.zoomLevel = 1
      }
    },

    // resize (value) {
    //   let delta = 100 * value
    //   let element = ($('.gallery-slider-container .gallery-slider .gallery-slider-box > img'))
    //   // let element = document.getElementById('img')
    //   let height = element.outerHeight
    //   let width = element.outerWidth
    //
    //
    //   element.css({'width':(width*value)+'px', 'height': (height*value)+'px'})
    //   // element.css({'width':delta+'px'})
    //   // element.style.width = delta + 'px'
    // },
    async getLargeImage (photo) {

      console.log('SliderDetails --- getLargeImage')

      let url = process.env.VUE_APP_GET_METHOD_URL + "img&projectid=" + photo.projectid + "&type=l&id=" + photo.id + `&token=` + localStorage.sessiontoken
      let _this = this
      await fetch(
        url,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
          }
        }
      ).then(response => response.blob())
        .then(response => {

          let reader = new FileReader()
          reader.readAsDataURL(response)
          reader.onloadend = function() {
            //_this.currentImage.src = reader.result
            _this.image.src = reader.result
            _this.makeCanvas()


            // let target = $('.gallery-slider-container .gallery-slider .gallery-slider-box > img')
            // target.on("mousewheel DOMMouseScroll",scrolled)
            //
            // function scrolled(e) {
            //
            //
            //   e.preventDefault();
            //   var delta = e.delta || e.originalEvent.wheelDelta;
            //   if (delta === undefined) {
            //     //we are on firefox
            //     delta = e.originalEvent.detail;
            //   }
            //   delta = Math.max(-1,Math.min(1,delta))
            //
            //   if(delta == 1) {
            //     _this.zoomIn()
            //   } else {
            //     _this.zoomOut()
            //   }
            //
            // }



          }

        })

    },
    toggleSliderView () {
      this.$store.commit('toggleSliderView')
    },
    previousImage () {
      this.$parent.previousImage()
    },
    nextImage () {
      this.$parent.nextImage()
    },
    // zoomOut () {
    //   if (this.zoom_value >= 1) {
    //     this.zoom_value -= 0.5
    //   }
    // },
    // zoomIn () {
    //   if (this.zoom_value <= 10) {
    //     this.zoom_value += 0.5
    //   }
    // }
  }
}
</script>
<style scoped>
img.img.img-fluid{
  max-height: -webkit-fill-available !important;
}
.btn-expand{
  position: absolute;
  right: 10px;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/photo/components/SliderDetails.vue